import { type ISelectionStrategy } from 'components/page/listing-grid-v1/strategies/abstract.selection.strategy';

export class SingleSelectionStrategy implements ISelectionStrategy {
    constructor(
        private selection,
        private noSelectionDefault?: boolean
    ) {}

    public update(items) {
        if (this.selection && this.selection.single && items.length) {
            if (!this.noSelectionDefault) {
                this.selection.toggle(items[0]);
            }
        }
    }
}
